import React, { useEffect } from "react";
import { BrowserRouter as Router, Route } from 'react-router-dom'
import HomeScreen from "./components/HomeScreen"
import Header from './components/Header'
import SubmitScreen from "./components/SubmitScreen";
import Mines from "./components/Mines";
import ReactGA from 'react-ga';
import { Privacy } from "./components/Privacy";


function App() {


  useEffect(() => {
    ReactGA.initialize('UA-213399999-1')
    ReactGA.pageview(window.location.pathname + window.location.search);


  }, [])




  return (
    <Router>
      <Header />
      <Route path='/search/:keyword' component={HomeScreen} exact />
      <Route path='/privacy' component={Privacy} exact />
      <Route path='/submit' component={SubmitScreen} exact />
      <Route path='/madebyme' component={Mines} exact />
      <Route path='/' component={HomeScreen} exact />

    </Router>
  );
}

export default App;
